import * as submittedListActionTypes from "./actionTypes";

export function fetchSubmittedWarrentyList(filters) {
    return {
        type: submittedListActionTypes.FETCH_SUBMITTED_WARRANTY_LIST,
        filters,
    };
}

export function fetchSubmittedWarrentyListSuccess(data) {
    return {
        type: submittedListActionTypes.FETCH_SUBMITTED_WARRANTY_LIST_SUCCESS,
        ...data,
    };
}

export function fetchSubmittedWarrentyListFailure() {
    return {
        type: submittedListActionTypes.FETCH_SUBMITTED_WARRANTY_LIST_FAILURE,
    };
}
export function updateActiveTab(tab) {
    return {
        type: submittedListActionTypes.UPDATE_ACTIVE_TAB,
        tab,
    };
}

export function resetSubmittedWarrantyList() {
    return {
        type: submittedListActionTypes.RESET_SUBMITTED_WARRANTY_LIST,
    };
}

export function fetchStateProviceList(country) {
    return {
        type: submittedListActionTypes.FETCH_STATE_PROVINCE_LIST,
        country,
    };
}

export function fetchStateProviceListSuccess(data) {
    return {
        type: submittedListActionTypes.FETCH_STATE_PROVINCE_LIST_SUCCESS,
        ...data,
    };
}

export function fetchStateProviceListFailure(err) {
    return {
        type: submittedListActionTypes.FETCH_STATE_PROVINCE_LIST_FAILURE
    };
}
